module.exports = __webpack_public_path__ + "img/sismik.79a9bce0.png";